
import './App.css';
import Home from './compenents/home';

function App() {
  return (
    <>
<Home/>
    </>
  )}

export default App;
